import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var SavePartyCommandClass;
function SavePartyCommand() {
  if (SavePartyCommandClass === VOID) {
    class $ {
      constructor(party) {
        this.m2l_1 = party;
      }
      toString() {
        return 'SavePartyCommand(party=' + this.m2l_1.toString() + ')';
      }
      hashCode() {
        return this.m2l_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyCommand()))
          return false;
        if (!this.m2l_1.equals(other.m2l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyCommand');
    SavePartyCommandClass = $;
  }
  return SavePartyCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher396y2mcz9r128,
  SavePartyCommand as SavePartyCommand1abunn98k4p0o,
};
//endregion

//# sourceMappingURL=SavePartyCommand.mjs.map
